export default "__VITE_ASSET__mj39hcWY__"